import { skipToken } from "@reduxjs/toolkit/query";
import { signalIdSchema } from "@repo/app-types/entities/signal";
import type { FC } from "react";
import { useGetSignalQuery } from "../../api/entities/signal.js";
import { renderCrumbLabel } from "../../app/navigation/crumbLabel.js";

/** Breadcrumb label for the signal drilldown and signal editor pages. */
export const SignalNameCrumbLabel: FC<{ signalId: string | undefined }> = ({
  signalId,
}) => {
  const parsedId = signalIdSchema.safeParse(signalId);
  const result = useGetSignalQuery(
    parsedId.success ? parsedId.data : skipToken,
  );
  return renderCrumbLabel({
    hasValidId: parsedId.success,
    result,
    buildText: (signal) => signal.name,
    fallbackText: "Signal",
  });
};
